import { admessageConstants } from '../constants';

const initialState = {
    loading: false,
    admessages: [],
    error: null,
    creatingAdmessage: false,
    createError: null,
    updatingAdmessage: false,
    updateError: null,
};

const admessageReducer = (state = initialState, action) => {
    switch (action.type) {
        case admessageConstants.FETCH_ADMESSAGES_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case admessageConstants.FETCH_ADMESSAGES_SUCCESS:
            return {
                ...state,
                loading: false,
                admessages: action.admessages,
                error: null
            };
        case admessageConstants.FETCH_ADMESSAGES_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        case admessageConstants.CREATE_ADMESSAGE_REQUEST:
            return {
                ...state,
                creatingAdmessage: true,
                createError: null,
            };
        case admessageConstants.CREATE_ADMESSAGE_SUCCESS:
            return {
                ...state,
                creatingAdmessage: false,
                admessages: action.admessages,
            };
        case admessageConstants.CREATE_ADMESSAGE_FAILURE:
            return {
                ...state,
                creatingAdmessage: false,
                createError: action.payload,
            };

        case admessageConstants.UPDATE_ADMESSAGE_REQUEST:
            return {
                ...state,
                updatingAdmessage: true,
                updateError: null,
            };
        case admessageConstants.UPDATE_ADMESSAGE_SUCCESS:
            return {
                ...state,
                admessages: action.admessages,
                updatingAdmessage: false,
                updateError: null,
            };
        case admessageConstants.UPDATE_ADMESSAGE_FAILURE:
            return {
                ...state,
                updatingAdmessage: false,
                updateError: action.payload,
            };
        case admessageConstants.DELETE_ADMESSAGE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case admessageConstants.DELETE_ADMESSAGE_SUCCESS:
            return {
                ...state,
                loading: false,
                admessages: state.admessages.filter(a => a.ADMessageID !== action.payload),
            };
        case admessageConstants.DELETE_ADMESSAGE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        default:
            return state;
    }
};

export default admessageReducer;
